import React, { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { ConfirmDialog } from '../../reports/edit/EditCommon';
import { SCHEDULE_LABELS, validateSchedule } from './revenueEntryCalc';
import type { EntrySchedule } from './revenueEntryApi';

interface EntryScheduleDialogProps {
  open: boolean;
  /** Текущее окно; форма заполняется при монтировании: на каждое открытие свой key */
  schedule: EntrySchedule;
  saving: boolean;
  /** Возвращает true, если окно сохранено и форму можно закрыть */
  onSave: (schedule: EntrySchedule) => Promise<boolean>;
  onClose: () => void;
}

const EntryScheduleDialog: React.FC<EntryScheduleDialogProps> = ({ open, schedule, saving, onSave, onClose }) => {
  const [openAt, setOpenAt] = useState(schedule.open);
  const [closeAt, setCloseAt] = useState(schedule.close);
  const [error, setError] = useState('');

  const submit = async () => {
    if (saving) return;
    const found = validateSchedule(openAt, closeAt);
    setError(found);
    if (found) return;
    // Окно не поменялось: сохранять нечего
    if (openAt === schedule.open && closeAt === schedule.close) {
      onClose();
      return;
    }
    if (await onSave({ open: openAt, close: closeAt })) onClose();
  };

  const timeField = (label: string, value: string, onChange: (value: string) => void) => (
    <TextField
      size="small"
      fullWidth
      required
      type="time"
      label={label}
      value={value}
      onChange={(event) => {
        onChange(event.target.value);
        setError('');
      }}
      error={!!error}
      InputLabelProps={{ shrink: true }}
      inputProps={{ step: 60 }}
    />
  );

  return (
    <ConfirmDialog
      open={open}
      title="Окно ввода"
      confirmText="Сохранить"
      loading={saving}
      maxWidth="xs"
      onConfirm={submit}
      onClose={onClose}
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        {timeField(SCHEDULE_LABELS.open, openAt, setOpenAt)}
        {timeField(SCHEDULE_LABELS.close, closeAt, setCloseAt)}
      </Box>
      <Typography sx={{ mt: 1.5, fontSize: '0.84rem', color: error ? '#dc2626' : '#64748b' }}>
        {error || 'Ввод за день открывается в указанное время этого дня и закрывается на следующий день. Одинаковое время - без блокировки.'}
      </Typography>
    </ConfirmDialog>
  );
};

export default EntryScheduleDialog;
